import { render } from "./ViewMediaFileMoreTvSimple.vue?vue&type=template&id=1ebf16ca&scoped=true"
import script from "./ViewMediaFileMoreTvSimple.vue?vue&type=script&lang=js"
export * from "./ViewMediaFileMoreTvSimple.vue?vue&type=script&lang=js"

import "./ViewMediaFileMoreTvSimple.vue?vue&type=style&index=0&id=1ebf16ca&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ebf16ca"

export default script